import React from 'react';
import { components } from 'app-webtech-core';
import { properties as desktopSelector } from 'app-modules/desktop/selectors';

const applicationParams = {
  appName: 'web',
  appVersion: process.env.APP_VERSION,
};

export const createEntrypoint = (ApplicationComponent, { store, persistor }) => {
  const isDesktop = desktopSelector(store.getState()).enabled;
  const params = {
    ...applicationParams,
    appName: isDesktop ? 'desktop' : applicationParams.appName,
  };

  return (
    <components.PlutoApplication store={store} persistor={persistor} {...params}>
      <ApplicationComponent />
    </components.PlutoApplication>
  );
};
